(function () {
	'use strict';

    angular.module("imApp").factory("incomingCallService", ['$ihttp', function ($ihttp) {
		let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 1359,
                    parameters: parms || {}
                });
            },
            listFindPersons: function (parms) {
                return $ihttp.post({
                    method: 1125,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
